module.exports = __webpack_public_path__ + "static/img/welcome.b969c6e6.png";